import clsx from "clsx";
import { TextField } from "@mui/material";
import { useStyles } from "../styles";

const CustomTextField = ({ handlePlayerScore, value }) => {
  const classes = useStyles();

  return (
    <TextField
      hiddenLabel
      variant="outlined"
      size="small"
      value={value.score === null ? "" : value.score}
      onChange={handlePlayerScore}
      autoComplete="off"
      defaultValue={0}
      inputProps={{ maxLength: 2 }}
      className={clsx(classes.outlineInputBorder, classes.outlineInput)}
    />
  );
};

export default CustomTextField;
